import React, { useState } from "react";
import { DashboardApi } from "../../../../../../core/api/dashboardApi";
import CustomModal from "../../../../../../layout/components/customModal";
import RenderSvg from "../../../../../../layout/components/icons/RenderSvg";
import "./style.scss";
import { TrackedItemsVariables } from "../../../../../../core/constants/TrackedItemsConstants";
const AIDrivenActionsComponent = ({ record, navigateToDashboard, isMyWatchlist = false, }) => {
    const [AIData, setAIData] = useState(undefined);
    const [visible, setVisible] = useState(false);
    const handleAIAnalysis = (record) => {
        DashboardApi.getAIDashboardResponse(record.key).then((response) => {
            setAIData(response);
            setVisible(true);
        }).catch((error) => {
            setVisible(true);
        });
    };
    const handleViewMore = (record) => {
        navigateToDashboard(record);
    };
    const onClose = () => {
        setVisible(false);
        setAIData(undefined);
    };
    const isTrackedItemAIAnalysis = record.category === "Tracked Item" && record.categoryId === TrackedItemsVariables.FinancialCategoryCode;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ai-driven-actions" }, isTrackedItemAIAnalysis && (React.createElement("div", { className: "ai-actions-group-2" },
            React.createElement(RenderSvg, { icon: "RodaAiGlass", onClick: () => handleAIAnalysis(record), style: { cursor: "pointer" } })))),
        React.createElement(CustomModal, { visible: visible, onCancel: onClose, maskClosable: false, destroyOnClose: true, footer: null, title: ["AI Analysis"], width: "50%" },
            React.createElement("div", { style: { paddingLeft: "7px" } },
                React.createElement("h4", { style: {
                        color: "#000000",
                        fontSize: "14px",
                        fontWeight: 700,
                        marginBottom: '10px'
                    } }, "Root Cause Analysis"),
                React.createElement("p", null, (() => {
                    var _a, _b, _c, _d;
                    // Check if analysis has not run yet
                    if (!(AIData === null || AIData === void 0 ? void 0 : AIData.latest_month) && !(AIData === null || AIData === void 0 ? void 0 : AIData.latest_year)) {
                        return 'The AI analysis will be generated once the latest data is ingested.';
                    }
                    // Check if status is 0 and no root cause exists (not in risk)
                    if ((AIData === null || AIData === void 0 ? void 0 : AIData.status) === 0 && !((_b = (_a = AIData === null || AIData === void 0 ? void 0 : AIData.analysis_report) === null || _a === void 0 ? void 0 : _a.json_report) === null || _b === void 0 ? void 0 : _b.root_cause)) {
                        return 'No Root Cause Analysis performed, as the KPI is not at risk.';
                    }
                    // Check if status is 1 or 4 (report not found)
                    if ((AIData === null || AIData === void 0 ? void 0 : AIData.status) === 1 || (AIData === null || AIData === void 0 ? void 0 : AIData.status) === 4) {
                        return 'AI Analysis failed for this KPI.';
                    }
                    // Default case: show root cause if it exists
                    return ((_d = (_c = AIData === null || AIData === void 0 ? void 0 : AIData.analysis_report) === null || _c === void 0 ? void 0 : _c.json_report) === null || _d === void 0 ? void 0 : _d.root_cause) || 'No Root Cause Analysis available.';
                })())),
            React.createElement("div", { style: {
                    textAlign: "center",
                    marginTop: '20px',
                    marginBottom: '10px',
                    // backgroundColor: "#ECF8F7" 
                } },
                React.createElement("button", { style: {
                        color: "#00B2B2",
                        fontWeight: 600,
                        fontSize: 13,
                        // textDecoration: "underline",
                        lineHeight: "20px",
                        letterSpacing: "0.2px",
                        cursor: "pointer",
                        minHeight: "20px",
                        borderRadius: "2px",
                        border: "none",
                        background: "none",
                        padding: 0,
                        width: "100%"
                    }, onClick: () => handleViewMore(record) }, "View More")))));
};
export default AIDrivenActionsComponent;
